import { isTelegramApp } from '@/utils/isTelegramApp';
import { parseStartParams } from '@/utils/parseStartParams';

import {
  closingBehavior,
  expandViewport,
  init,
  retrieveLaunchParams,
  viewport,
} from '@telegram-apps/sdk-react';

async function getPlatform() {
  if (isTelegramApp()) {
    try {
      const { retrieveLaunchParams } = await import('@telegram-apps/sdk-react');
      return retrieveLaunchParams().platform || '';
    } catch (error) {
      console.error('Error retrieving launchParams:', error);
      return '';
    }
  }
  return '';
}

export const initTelegramApp = async () => {
  const start = performance.now();
  console.log('[PERF] 📱 Telegram SDK initialization started');

  const initStart = performance.now();
  init();
  console.log(
    `[PERF] ✅ SDK init() completed in ${(performance.now() - initStart).toFixed(2)}ms`,
  );

  const expandStart = performance.now();
  expandViewport();
  console.log(
    `[PERF] ✅ expandViewport() completed in ${(performance.now() - expandStart).toFixed(2)}ms`,
  );

  const behaviorStart = performance.now();
  closingBehavior.mount();
  closingBehavior.enableConfirmation();
  console.log(
    `[PERF] ✅ closingBehavior setup completed in ${(performance.now() - behaviorStart).toFixed(2)}ms`,
  );

  const platformStart = performance.now();
  const platform = await getPlatform();
  console.log(
    `[PERF] ✅ Platform detection completed in ${(performance.now() - platformStart).toFixed(2)}ms`,
    { platform },
  );

  const FS_PLATFORMS = ['ios', 'android', 'android_x'];
  const shouldSupportFullscreen = FS_PLATFORMS.includes(platform);

  if (shouldSupportFullscreen) {
    const fullscreenStart = performance.now();
    await viewport.mount();
    console.log(
      `[PERF] ✅ viewport.mount() completed in ${(performance.now() - fullscreenStart).toFixed(2)}ms`,
    );

    document.documentElement.setAttribute('data-platform', 'mobile');

    if (viewport.requestFullscreen.isAvailable()) {
      const requestStart = performance.now();
      await viewport.requestFullscreen();
      console.log(
        `[PERF] ✅ viewport.requestFullscreen() completed in ${(performance.now() - requestStart).toFixed(2)}ms`,
      );
    }
  }

  const paramsStart = performance.now();
  const startParams = retrieveLaunchParams().initData?.startParam;
  console.log(
    `[PERF] ✅ retrieveLaunchParams() completed in ${(performance.now() - paramsStart).toFixed(2)}ms`,
  );

  console.log(
    `[PERF] 🎉 Total Telegram init time: ${(performance.now() - start).toFixed(2)}ms`,
  );

  if (startParams) {
    return {
      startParams: parseStartParams(startParams),
      shouldSupportFullscreen,
    };
  }
  return { startParams: null, shouldSupportFullscreen };
};
